import React, { useEffect, useState } from "react";
import {
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Avatar,
  Text,
  Spinner,
  Box,
  Button,
  Flex,
  Select,
  Stack,
} from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";
import { useToast } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import EditTrsList from "./Edit_trs_list";
import Admin_modal_tr_allocate_table from "./Admin_modal_tr_allocate_table";
import { BASE_URL } from "../../../Globalapi/Globalapi";
const List_bus_tr_view = () => {
  const [payFee, setPayFee] = useState([]);

  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const { id } = useParams(); // Extract busRouteId from URL parameters
  const schoolId = sessionStorage.getItem("school_id");
  const toast = useToast();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchTeachers();
  }, [schoolId, id]);

  const fetchTeachers = async () => {
    if (!schoolId || !id) {
      setError("School ID or Bus Route ID is missing.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL}/admin/bus/teachers/list_bus_teachers.php?school_id=${schoolId}&bus_route_id=${id}`
      );
      const data = await response.json();
      console.log("allocate trs list", data);

      if (data.success) {
        setTeachers(data.data); // Assuming data contains the teacher list
      } else {
        setError(data.message || "Failed to fetch teachers.");
      }
    } catch (err) {
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const RefreshData = () => {
    fetchTeachers();
  };
  const handleDeleteTeacher = async (teacherId, allocationId) => {
    try {
      const response = await fetch(`${BASE_URL}/admin/bus/teachers/delete_teachers.php`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: sessionStorage.getItem("user_id"),
            school_id: schoolId,
            teacher_id: teacherId,
            allocation_id: allocationId,
          }),
        }
      );
      const data = await response.json();

      if (data.success) {
        toast({
          title: "Success",
          description: "Teacher allocation deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        // Refresh the list of teachers after deletion
        setTeachers((prevTeachers) =>
          prevTeachers.filter((teacher) => teacher.teacher_id !== teacherId)
        );
      } else {
        toast({
          title: "Error",
          description: data.message || "Failed to delete teacher allocation.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error deleting teacher allocation:", error);
      toast({
        title: "Error",
        description: "An error occurred while deleting allocation.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Pagination logic
  const totalPages = Math.ceil(teachers.length / rowsPerPage);
  const currentData = teachers.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when rows per page change
  };

  if (loading) {
    return <Spinner size="xl" />;
  }

  if (error) {
    return <Text color="red.500">{error}</Text>;
  }

  return (
    <Box>
      <Box overflowX="auto" maxWidth="100%">
        <Table
          sx={{
            "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
          }}
          size="md"
        >
          <Thead>
            <Tr>
              <Th>Teacher Name</Th>
              <Th>Pickup Point</Th>
              <Th>Drop Point</Th>
              <Th>Start Date</Th>
              <Th>End Date</Th>
              <Th>Due Date</Th>
              <Th>Bus Fee</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {currentData.map((teacher) => (
              <Tr key={teacher.teacher_id}>
                <Td>
                  <Box display="flex" alignItems="center" gap={2}>
                    <Avatar
                      size="sm"
                      src={teacher.avatar}
                      name={teacher.name}
                    />
                    <Text>{teacher.name}</Text>
                  </Box>
                </Td>
                <Td>{teacher.pickup_location}</Td>
                <Td>{teacher.drop_location}</Td>
                <Td>{teacher.start_date}</Td>
                <Td>{teacher.end_date}</Td>
                <Td>{teacher.due_date}</Td>
                <Td>{teacher.bus_fee}</Td>
                <Td>
                  <Box display="flex" gap={2}>
                    <EditTrsList
                      RefreshData={RefreshData}
                      teacher={teacher.teacher_id}
                      allocation_id={teacher.allocation_id}
                    />
                    <Button
                      colorScheme="red"
                      size="sm"
                      leftIcon={<FaTimes />}
                      onClick={() =>
                        handleDeleteTeacher(
                          teacher.teacher_id,
                          teacher.allocation_id
                        )
                      }
                    />

                    <Button
                      colorScheme="teal"
                      variant="solid"
                      width="full"
                      size="sm"
                      fontWeight="bold"
                      onClick={() => {
                        handleOpenModal();
                        setPayFee(teacher);
                      }}
                    >
                      Pay
                    </Button>
                  </Box>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
      {isModalOpen && (
        <Admin_modal_tr_allocate_table
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          // amount={transportInfo.transportFee}
          // last={transportInfo.paymentDueDate}
          // start={transportInfo.startDate}
          // feeId={transportInfo.recordId}
          staffId={payFee.teacher_id}
          userId={payFee.user_id}
        />
      )}

      <Flex justify="end" align="center" className="sb2" p={3}>
        {/* <Select
          width="120px"
          value={rowsPerPage}
          onChange={handleRowsPerPageChange}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
        </Select> */}

        <Flex align="center">
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
          >
            Prev
          </Button>

          <Stack direction="row" spacing={2} mx={2}>
            {Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i}
                onClick={() => handlePageChange(i + 1)}
                colorScheme={currentPage === i + 1 ? "teal" : "gray"}
              >
                {i + 1}
              </Button>
            ))}
          </Stack>

          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default List_bus_tr_view;
